import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import TextFieldValidation from "../../../customer-detales/TextFieldValidation";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import React, {useState} from "react";
import Typography from "@mui/material/Typography";
import CalculatorModal from "../../../../сalculator/CalculatorModal";

const EditEstimateModal = ({open, onClose, onSubmit, initFormState}) => {
    const [formState, setFormState] = useState(initFormState)
    const [calculatorOpen, setCalculatorOpen] = useState("")
    const [position, setPosition] = useState({x: 0, y: 0})

    const handleSubmit = (data, close) => {
        if (data !== undefined) {
            setFormState({...formState, [calculatorOpen]: {...formState[calculatorOpen], price: data}})
        }
        close()
    }

    const inputHandler = (getData) => {
        const [key, value] = Object.entries(getData())[0]
        setFormState(prev => ({...prev, [key]: {...prev[key], price: value}}))
    }
    return (
        <Dialog open={open}
                PaperProps={{
                    sx: {minWidth: "400px"}
                }}>
            <DialogTitle
                textAlign="center">Изменить</DialogTitle>
            <DialogContent>
                <FormControl sx={{minWidth: "100%"}}>
                    <Box sx={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                        <Box sx={{
                            minWidth: 350,
                        }}>
                            <Box sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center"
                            }}>
                              
                            </Box>

                            <TextFieldValidation
                                name={"costBasePrice"}
                                required={false}
                                value={formState?.costBasePrice?.price}
                                label="Себестоимость материалов"
                                setCurrValues={inputHandler}
                                adornment={formState?.costBasePrice?.prevPrice && `${formState?.costBasePrice?.prevPrice?.toFixed(2)} (предыдущее)`}
                                setCalculatorOpen={setCalculatorOpen}
                                setPosition={setPosition}
                            />
                            <TextFieldValidation
                                name={"jobCostBasePrice"}
                                required={false}
                                value={formState?.jobCostBasePrice?.price}
                                label="Себестоимость работ"
                                setCurrValues={inputHandler}
                                adornment={formState?.jobCostBasePrice?.prevPrice && `${formState?.jobCostBasePrice?.prevPrice?.toFixed(2)} (предыдущее)`}
                                setCalculatorOpen={setCalculatorOpen}
                                setPosition={setPosition}
                            />
                            <TextFieldValidation
                                name={"basePrice"}
                                required={false}
                                value={formState?.basePrice?.price}
                                label="Стоимость материалов"
                                setCurrValues={inputHandler}
                                adornment={formState?.basePrice?.prevPrice && `${formState?.basePrice?.prevPrice?.toFixed(2)} (предыдущее)`}
                                setCalculatorOpen={setCalculatorOpen}
                                setPosition={setPosition}
                            />
                            <TextFieldValidation
                                name={"baseJobPrice"}
                                required={false}
                                value={formState?.baseJobPrice?.price}
                                label="Стоимость работ"
                                setCurrValues={inputHandler}
                                adornment={formState?.baseJobPrice?.prevPrice && `${formState?.baseJobPrice?.prevPrice?.toFixed(2)} (предыдущее)`}
                                setCalculatorOpen={setCalculatorOpen}
                                setPosition={setPosition}
                            />
                        </Box>
                        <CalculatorModal
                            open={calculatorOpen}
                            onClose={() => setCalculatorOpen("")}
                            position={position}
                            handleSubmit={handleSubmit}/>
                    </Box>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Отменить"} onClick={onClose}/>
                <ButtonAdd text={"Изменить"} onClick={() => onSubmit(formState)}/>
            </DialogActions>
        </Dialog>
    )
}
export default EditEstimateModal